import { render, staticRenderFns } from "./sup-how-to-register.vue?vue&type=template&id=7c5b936e"
import script from "./sup-how-to-register.vue?vue&type=script&lang=js"
export * from "./sup-how-to-register.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports